import axios from "axios";

function getNextPage(page) {
    $(".loading").css("visibility", "inherit");
    axios
        .get(page, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            const container = $(".highlight-list");
            if (response.data.content) {
                container.append(response.data.content);

                $(".loading").css("visibility", "hidden");

                if (response.data.hasMorePages) {
                    $(".load-more-action").attr(
                        "data-nextpage",
                        response.data.nextPageUrl
                    );
                } else {
                    $(".load-more-action").attr("data-nextpage", "0");
                    $(".load-more").css("visibility", "hidden");
                }
            }
        });
}

$("body").on("click", ".load-more-action", function (e) {
    e.stopPropagation();
    e.preventDefault();
    const element = e.target;
    var nextpage = element.getAttribute("data-nextpage");
    if (nextpage !== "0") {
        getNextPage(nextpage);
    }
});

window.getNextPage = getNextPage;
